// @ts-ignore
import Splide from '@splidejs/splide';
// @ts-ignore
import debounce from 'lodash/debounce';

export class Slider {
  slider: HTMLElement;

  constructor(slider) {
    this.slider = slider
    this.init();
  }

  init() {
    this.addTriggerEvents();
  }

  addTriggerEvents() {
    let splide;
    switch (this.slider.dataset.slider) {
      case 'footer':
        splide = new Splide(this.slider, {
          type: 'slide',
          rewind: true,
          autoplay: true,
          interval: 3000,
          pagination: false,
          gap: 32,
          perPage: 2,
          perMove: 1,
          mediaQuery: 'min',
          breakpoints: {
            576: {
              perPage: 3
            },
            768: {
              perPage: 4
            },
            992: {
              perPage: 5
            }
          }
        });
        break;
      default:
        splide = new Splide(this.slider, {
          type: 'slide',
          gap: 32,
          perPage: 1,
          perMove: 1,
          mediaQuery: 'min',
          breakpoints: {
            768: {
              perPage: 2
            },
            992: {
              perPage: 3
            }
          }
        });
    }

    splide.mount();

    this.updateSliderState(splide);

    window.addEventListener('resize', debounce(() => {
      this.updateSliderState(splide);
    }, 100));
  }

  updateSliderState(slider) {
    const is_enabled = slider.length > slider.options.perPage;

    slider.options = {
      'arrows':   is_enabled,
      'drag':     is_enabled,
      'keyboard': is_enabled,
    };

    if (!is_enabled) {
      slider.remove('.splide__slide--clone');
      slider.root.classList.add('no-slider');
    }
    else {
      slider.root.classList.remove('no-slider');
    }
  }

}
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll<HTMLElement>('[data-slider]').forEach((slider: HTMLElement) => {
    new Slider(slider);
  });
});
